import { useState } from "react";
import UploadImage from "../api/UploadImage";
import updateItem from "../api/updateItem";
import AlertComponent from "../../../components/AlertComponent";
import ErrorAlert from "../../../components/ErrorAlert";

const ItemExpandUpdatingPicture = ({ item, onImageUpdated, showAllFields = false }) => {
  const [errorAlert, setErrorAlert] = useState(false);
  const [updateAlert, setUpdateAlert] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [itemName, setItemName] = useState(item.name);
  const [itemIraqiPrice, setItemIraqiPrice] = useState(item.iraqiprice);

  const handleUpdatingItemDetails = async () => {
    // Check if the values are different from the initial values
    if (itemName !== item.name || itemIraqiPrice !== item.iraqiprice) {
      const detailsData = {
        itemId: item.id,
        name: itemName,
        iraqiprice: itemIraqiPrice,
      };

      const status = await updateItem(detailsData);
      if (status.message !== "Item updated !") {
        setErrorAlert(true);
        return false; // Stop further execution
      } else {
        setItemName(itemName);
        setItemIraqiPrice(itemIraqiPrice);
        setUpdateAlert(true);
      }
    }
    return true; // Success
  };

  const handleUpdatingImageItem = async (e) => {
    e.preventDefault();
    let success = true;

    success = await handleUpdatingItemDetails();
    if (!success) return;

    if (selectedFile) {
      // Only call API if a new file is selected
      const imageData = {
        dataId: item.id,
        imageFile: selectedFile,
      };

      const status = await UploadImage(imageData);
      if (status === 200) {
        setErrorAlert(false);
        onImageUpdated();
        setUpdateAlert(true);
      } else {
        setErrorAlert(true);
      }
    }
  };

  return (
    <>
      <tr className="border">
        <td colSpan="10" className="p-2">
          <div className="flex flex-col items-end">
            {errorAlert ? (
              <ErrorAlert
                title={"فشل تحديث المعلومات"}
                content={"يرجى التأكد من إدخال معلومات صحيحة والمحاولة مرة أخرى لاحقا"}
              />
            ) : (
              ""
            )}
            {updateAlert ? (
              <AlertComponent
                title={"تم تحديث المعلومات بنجاح"}
                content={`تمت إضافة المعلومات جديد بإسم  ${item.name}  بنجاح`}
              />
            ) : (
              ""
            )}
            <form className="w-full" onSubmit={handleUpdatingImageItem}>
              <div className="relative mb-4 flex w-full flex-col items-end">
                <label className="text-sm leading-7 text-gray-600">الإسم</label>
                <input
                  type="text"
                  value={itemName}
                  onChange={(e) => setItemName(e.target.value)}
                  dir="rtl"
                  required={false}
                  className="w-full rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                />
              </div>
              {showAllFields && (
                <>
                  <div className="relative mb-4 flex w-full flex-col items-end">
                    <label className="text-sm leading-7 text-gray-600">السعر العراقي</label>
                    <input
                      type="number"
                      min="0"
                      value={itemIraqiPrice}
                      onChange={(e) => setItemIraqiPrice(e.target.value)}
                      dir="rtl"
                      required={false}
                      className="w-full text-right rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                    />
                  </div>
                </>
              )}
              <div className="relative mb-4 flex w-full flex-col items-end">
                <label className="text-sm leading-7 text-gray-600">صورة المنتج</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                  dir="rtl"
                  required={false}
                  className="w-full text-right rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                />
              </div>
              <button
                type="submit"
                className="rounded border-0 bg-indigo-500 px-6 py-2 text-lg text-white hover:bg-indigo-600 focus:outline-none"
              >
                تعديل
              </button>
            </form>
          </div>
        </td>
      </tr>
    </>
  );
};

export default ItemExpandUpdatingPicture;
